export function minTargetCPASelector(state) {
    const currentCPCDesktop = parseFloat(
        parseFloat(state.formData.cpc).toFixed(2)
    );
    const currentCPCMobile = parseFloat(
        parseFloat(state.formData.cpcMobile).toFixed(2)
    );
    return Math.max(currentCPCDesktop, currentCPCMobile);
}
